import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  class: "d-flex justify-content-end",
  "data-kt-subscription-table-toolbar": "base"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "svg-icon svg-icon-2" }
const _hoisted_9 = {
  id: "kt_auction_create_details",
  class: "collapse show"
}
const _hoisted_10 = { class: "card-body border-top p-9" }
const _hoisted_11 = { class: "row mb-6" }
const _hoisted_12 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_13 = { class: "required" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "indicator-label" }
const _hoisted_22 = { class: "indicator-progress" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PackagesListing = _resolveComponent("PackagesListing")!
  const _component_PackagesCreating = _resolveComponent("PackagesCreating")!
  const _component_PackagesEditing = _resolveComponent("PackagesEditing")!
  const _component_ImportPackages = _resolveComponent("ImportPackages")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('shipmentDetails') + ' (' + _ctx.shipment.tracknumber + ')'), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "reset",
              class: "btn btn-white btn-active-light-primary me-2",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
            }, _toDisplayString(_ctx.translate('backToList')), 1),
            (_ctx.can('update', 'change-status'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  disabled: !_ctx.shipment.isEditable,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (
              _ctx.$router.push(`/manage/shipments/shipment-updating/${_ctx.shipment.id}`)
            )),
                  class: "btn btn-primary"
                }, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.translate('changeStatus')), 1)
                ], 8, _hoisted_7))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Form, {
          class: "form",
          onSubmit: _ctx.onSubmitUpdate,
          "validation-schema": _ctx.shipmentsSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.translate('selectOffice')), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "officeId",
                    class: "form-select form-select-solid form-select-lg text-capitalize",
                    modelValue: _ctx.shipment.officeId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shipment.officeId) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.translate('selectOffice')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offices, (office) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: office.id,
                          value: office.id
                        }, _toDisplayString(office.titleTranslate), 9, _hoisted_16))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "officeId" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                type: "submit",
                id: "kt_auction_create_details_submit",
                ref: "submitButton",
                disabled: !_ctx.shipment.isEditable,
                class: "btn btn-primary"
              }, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_22, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_23
                ])
              ], 8, _hoisted_20)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createVNode(_component_PackagesListing, {
      "created-shipment": _ctx.shipment,
      onListChanged: _ctx.refreshPackages,
      onShowEditPackagesModal: _ctx.showPackagesEditModal
    }, null, 8, ["created-shipment", "onListChanged", "onShowEditPackagesModal"]),
    _createVNode(_component_PackagesCreating, {
      "shipment-id": _ctx.shipment.id,
      "status-id": _ctx.shipment.statusId,
      onListChanged: _ctx.refreshPackages
    }, null, 8, ["shipment-id", "status-id", "onListChanged"]),
    _createVNode(_component_PackagesEditing, {
      "edit-data": _ctx.editData,
      "status-id": _ctx.shipment.statusId,
      onListChanged: _ctx.refreshPackages
    }, null, 8, ["edit-data", "status-id", "onListChanged"]),
    _createVNode(_component_ImportPackages, {
      "shipment-id": _ctx.shipment.id,
      "edit-data": _ctx.editData,
      onListChanged: _ctx.refreshPackages
    }, null, 8, ["shipment-id", "edit-data", "onListChanged"])
  ], 64))
}